import { NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '@environments/environment';
import { SafeHtmlPipe } from '@pipes/safe-html.pipe';
import { FormService } from '@services/form.service';

@Component({
  selector: 'app-consultation-request-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule, ReactiveFormsModule, NgIf, SafeHtmlPipe],
})
export class TermsOfServiceComponent implements OnInit {
  public showTerms: boolean = false;
  public wmgTermsContent: string = 'Loading...';
  public consultationForm: FormGroup;

  private formService = inject(FormService);
  private http = inject(HttpClient);

  /**
   * Get the terms of service URL.
   */
  public get tosUrl(): string {
    return `${environment.analyteCareApi}/api/v2/public-files/wilcrest-tos.html`;
  }

  /**
   * Set the consultation form.
   */
  public ngOnInit(): void {
    this.consultationForm = this.formService.consultationRequest;
    this.getWmgTermsOfService();
  }

  /**
   * Show/hide terms.
   */
  public toggleTerms(): void {
    this.showTerms = !this.showTerms;
  }

  /**
   * Get Wilcrest Medical Group's terms and conditions.
   */
  private getWmgTermsOfService(): void {
    this.http.get(this.tosUrl, { responseType: 'text' }).subscribe({
      next: (response) => (this.wmgTermsContent = response),
      error: () => (this.wmgTermsContent = undefined),
    });
  }
}
